import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import IncomeAddChild from "./IncomeAddChild";

const IncomeAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <IncomeAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default IncomeAdd;
